// The list is visible while it has server notices or a client notice of a
// type it renders. Visibility and mechanism: docs/clubhouse/notices.md
export default () => ({
    hasServerContent: false,
    types: null,
    init() {
        this.hasServerContent = this.$el.dataset.serverContent === 'true'
        this.types = this.$el.dataset.types ? JSON.parse(this.$el.dataset.types) : null
    },
    get visible() {
        return this.hasServerContent
            || this.$store.notices.items.some((item) => this.types === null || this.types.includes(item.type))
    },
})

// Client notices for the page's notice stack. `html` is server-rendered
// markup, never user input: the stack binds it with x-html.
export const noticeStore = {
    /** @type {{ type: string, html: string }[]} */
    items: [],
    push(type, html) {
        this.items.push({ type, html })
    },
    clear(type = null) {
        this.items = type ? this.items.filter((item) => item.type !== type) : []
    },
    ofType(type) {
        return this.items.filter((item) => item.type === type)
    },
}
